import type { PageTourKey } from '@/lib/tours/registry';
import type { StartPageTourOptions } from '@/components/tour/PageTourHost';

/** Radix popovers can swallow clicks when focus moves before the click event — start the tour first. */
export function startTourFromPopover(
  startPageTour: (key: PageTourKey, options?: StartPageTourOptions) => void,
  tourKey: PageTourKey,
  closePopover: () => void,
): void {
  startPageTour(tourKey, { skipWelcomeDialog: true });
  window.requestAnimationFrame(() => {
    closePopover();
  });
}
